export default __webpack_public_path__ + "static/media/ic_arrrow-right.f81f6230.svg";